import { useEffect } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';

import { useSyncLayerVisibilityPreferences } from '@/modules/layers';
import { useLoadUserPreferences } from '@/modules/userPreferences/hooks';

export const useApp = () => {
  const isAuthenticated = useIsAuthenticated();
  const { load: loadUserPreferences } = useLoadUserPreferences();
  const syncLayerVisibilityPreferences = useSyncLayerVisibilityPreferences();

  useEffect(() => {
    if (!isAuthenticated) return;

    loadUserPreferences().then((userPreferencesWereLoaded) => {
      if (!userPreferencesWereLoaded) return;

      syncLayerVisibilityPreferences();
    });
  }, [isAuthenticated, loadUserPreferences, syncLayerVisibilityPreferences]);
};
